export const SPORT_ASSETS: Record<string, string> = {
  volleyball: "/hero_volleyball.jpg",
  icehockey: "/hero_icehockey.jpg",
  soccer: "/hero_soccer.jpg",
  basketball: "/hero_home.jpg",
  baseball: "/hero_baseball.jpg"
};
